<template>
  <div>
    <event-dashboard />
  </div>
</template>

<script>
  import EventDashboard from '@/components/eventDashboard/EventDashboard.vue'

  export default {
    components: {
      EventDashboard
    }
  }
</script>
